export const emptyPickupLocation = (isPrimary = false) => ({
  id: null,
  name: "",
  latitude: "",
  longitude: "",
  is_primary: isPrimary,
});

export const normalizePickupLocationsFromRental = (rental) => {
  const rows = rental?.pickup_locations;
  if (Array.isArray(rows) && rows.length) {
    const hasPrimary = rows.some((r) => r.is_primary);
    return rows.map((r, i) => ({
      id: r.id ?? null,
      name: r.name ?? "",
      latitude: r.latitude ?? "",
      longitude: r.longitude ?? "",
      is_primary: Boolean(r.is_primary) || (!hasPrimary && i === 0),
    }));
  }

  const name = String(rental?.location || "").trim();
  if (name) {
    return [
      {
        id: null,
        name,
        latitude: rental.latitude ?? "",
        longitude: rental.longitude ?? "",
        is_primary: true,
      },
    ];
  }

  return [emptyPickupLocation(true)];
};

export const syncPrimaryLocationFields = (locations) => {
  const primary = locations.find((l) => l.is_primary) || locations[0];
  return {
    location: primary?.name || "",
    latitude: primary?.latitude ?? "",
    longitude: primary?.longitude ?? "",
  };
};

export const validatePickupLocations = (locations) => {
  const errors = {};
  const rows = Array.isArray(locations) ? locations : [];
  const namedRows = rows
    .map((loc, index) => ({ loc, index }))
    .filter(({ loc }) => String(loc?.name || "").trim() !== "");

  if (namedRows.length === 0) {
    errors.pickup_locations = "Add at least one pickup location.";
    return errors;
  }

  namedRows.forEach(({ loc, index }) => {
    const name = String(loc.name || "").trim();
    if (name.length > 500) {
      errors[`pickup_locations.${index}.name`] = "Location must be at most 500 characters.";
    }

    const latS = String(loc.latitude ?? "").trim();
    const lngS = String(loc.longitude ?? "").trim();
    if (latS && !lngS) {
      errors[`pickup_locations.${index}.longitude`] = "Enter longitude when latitude is set.";
    }
    if (lngS && !latS) {
      errors[`pickup_locations.${index}.latitude`] = "Enter latitude when longitude is set.";
    }
    if (latS) {
      const lat = Number(latS);
      if (!Number.isFinite(lat) || lat < -90 || lat > 90) {
        errors[`pickup_locations.${index}.latitude`] = "Latitude must be between -90 and 90.";
      }
    }
    if (lngS) {
      const lng = Number(lngS);
      if (!Number.isFinite(lng) || lng < -180 || lng > 180) {
        errors[`pickup_locations.${index}.longitude`] = "Longitude must be between -180 and 180.";
      }
    }
  });

  return errors;
};

export const filterPickupLocationsForSave = (locations) =>
  (Array.isArray(locations) ? locations : []).filter(
    (loc) => String(loc?.name || "").trim() !== ""
  );

export const serializePickupLocationsForSave = (locations) =>
  filterPickupLocationsForSave(locations).map((loc, i) => ({
    id: loc.id ?? null,
    name: String(loc.name || "").trim(),
    latitude: loc.latitude === "" || loc.latitude == null ? null : Number(loc.latitude),
    longitude: loc.longitude === "" || loc.longitude == null ? null : Number(loc.longitude),
    is_primary: Boolean(loc.is_primary),
    sort_order: i,
  }));
